import { Component, OnInit } from '@angular/core';
import { PublisherService } from '../../../core/services/publisher.service';
import { Regex, CacheConstant } from '../../../core/constants/app.constant';
import { NgForm } from '@angular/forms';
import { OktaService } from '../okta.service';
import { HttpError } from '../../../shared/models/http-error';
import { OktaOperation } from '../okta-operation';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { OktaConstant } from '../okta.constant';
import { BaseComponent } from '../../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../../core/services/init/app-config.service';

@Component({
  selector: 'par-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends BaseComponent implements OnInit {
  /***************Properties***************/
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  websiteName: string = this.envProperties.theme;
  operation: OktaOperation = null;
  messages: any = {
    passwordHint: OktaConstant.Messages.ChangePasswordHintMessage
  };
  validation: any = {
    passwordRegex: Regex.Password
  };
  reset: any = {
    newPassword: '',
    confirmPassword: '',
    pattern: Regex.Password,
    errorMessage: ''
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(private oktaService: OktaService, 
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService,
    private cache: AppCacheService) {
    super(deviceDetectorService, cache, appConfig);
  }

  ngOnInit() {
    PublisherService.changeBannerHeader('Reset Password');
    this.operation = AppUtilService.cache.get(CacheConstant.Okta_Operation);

    if (this.operation && this.operation.data && this.operation.data.oktaId) {
      AppUtilService.cache.remove(CacheConstant.Okta_Operation);
    } else {
      AppUtilService.redirectToHome();
    }
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onCancelClick() {
    // AppUtilService.redirectToHome();
    if (!this.isMobileDevice()) {
      AppUtilService.redirectToHome();
    } else {
      AppUtilService.redirectToHomeMobile();
    }
  }

  onResetPasswordSubmit(resetForm: NgForm) {
    if (resetForm.invalid) {
      return;
    }

    const resetPasswordObj = {
      newPassword: this.reset.newPassword,
      oktaUserId: this.operation.data.oktaId,
      source: this.operation.source,
      stateToken: this.operation.data.stateToken,
      buId: this.envProperties.buId
    };

    this.oktaService
      .resetPassword(resetPasswordObj)
      .subscribe((response: any) => {
        if (response && response.hasError) {
          this.reset.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
        } else {
          AppUtilService.message.success(
            OktaConstant.Messages.ResetPasswordSuccessMesssage
          );
          AppUtilService.redirectToHome();
        }
      });
  }

  /***************Component Methods***************/
}
